export default "https://cdn-static.gokick.com/assets/f7932cbd9535e06fbf9353fcd5d5fd5cf044a6ff/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";